import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function RingStartPositionRow() {
   return (
      <InputRangeRow
         titleProp={"Starting Start Position"}
         descriptionProp={"mm"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={5.0}
         maxProp={50.0}
         propertyNameProp={"ringStartPos"}
         errorDialogueProp={"5.0-50.0"}
         floatProp={true}
      />
   );
}
